export default __webpack_public_path__ + "static/media/play.08378d4e.png";